<template>
  <div class="app-container page-detail">
    <basic-container>
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本资料" name="detail">
          <el-row class="page-detail-item">
            <el-col :span="2">页面名称:</el-col>
            <el-col :span="16">{{pageDetail.name}}</el-col>
          </el-row>
          <el-row class="page-detail-item" type="flex" align="bottom">
            <el-col :span="2">描述:</el-col>
            <el-col :span="16">{{pageDetail.description}}</el-col>
          </el-row>
          <el-row class="page-detail-item" >
            <el-col :span="2">正文:</el-col>
            <el-col :span="16">
              <div class="page-content" v-if="pageDetail.contentType == 1">
                <div v-html="pageDetail.content"></div>
              </div>
              <div class="page-content page-content-text" v-else>{{pageDetail.content}}</div>
            </el-col>
          </el-row>
          <el-row class="page-detail-item">
            <el-col :span="2">页面标识:</el-col>
            <el-col :span="16">{{ pageDetail.code }}</el-col>
          </el-row>
          <el-row class="page-detail-item">
            <el-col :span="2">创建时间:</el-col>
            <el-col :span="16">{{ pageDetail.insertedTime }}</el-col>
          </el-row>
          <el-row class="page-detail-item">
            <el-col :span="2">更新时间:</el-col>
            <el-col :span="16">{{ pageDetail.updatedTime }}</el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="预览" name="preview">
          <div class="preview">
            <div class="phoneBorder">
              <div class="page-content" v-if="pageDetail.contentType == 1">
                <div v-html="pageDetail.content"></div>
              </div>
              <div class="page-content page-content-text" v-else>{{pageDetail.content}}</div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-button round @click="handleBack">返回</el-button>

    </basic-container>
  </div>
</template>

<script>
import {getBasicPageById} from '@/api/basic/basicpage'

const initDetail = vm => {
  getBasicPageById(vm.id).then(response => {
    let data = response.data
    if (response.status == 200) {
      formatpageDetail(vm.pageDetail, data.data);
    } else {
      vm.$message({
        showClose: true,
        message: '无法查看该网页素材详情',
        type: 'error'
      });
    }
  }).catch(error => {
    vm.$message({
      message: '获取网页素材详情失败',
      type: 'error'
    });
  });
}

const formatpageDetail = (vm, data) => {
  vm.id = data.id;
  vm.name = data.name;
  vm.description = data.description;
  vm.content = data.content;
  vm.code = data.code;
  vm.insertedTime = data.insertedTime;
  vm.updatedTime = data.updatedTime;
  vm.contentType = data.contentType;
  if(!vm.description) vm.description = "--";
  if(!vm.content) vm.content = "--";
  if(!data.isDeleted) {
    vm.isDeleted = "正常"
  } else {vm.isDeleted = "已删除"};
  if(!vm.code) vm.code = "--";
  if(!vm.insertedTime) vm.insertedTime = "--";
  if(!vm.updatedTime) vm.updatedTime = "--";
}

export default {
  data () {
    return {
      id: 0,
      activeName: "detail",
      pageDetail:{
        id: "",
        name: "",
        description: "",
        content: "",
        contentType: "",
        code: "",
        isDeleted: "",
        insertedTime: "",
        updatedTime: "",
      },
    }
  },
  watch: {
    $route () {
      this.id = this.$route.params.id
      initDetail(this)
    }
  },
  mounted () {
    this.id = this.$route.params.id
    initDetail(this)
  },
  methods: {
    handleBack() {
      this.$router.push({
        path: '/basicpage/list'
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.page-detail {
  .page-detail-item {
    font-size: 16px;
    margin: 10px 0;
    &-button {
      margin: 0 0;
      color: #409EFF;
      text-align: center;
    }
  }
  &-item-picture-right {
    font-size: 16px;
    display: table-cell;
    &-item {
      display: inline-block;
      margin-right: 5px;
      margin-top: 5px;
    }
    &-pageer {
      position: relative;
      &-icon {
        position: absolute;
        color: #ffffff;
        top: 30px;
        left: 30px;
        font-size: 40px;
      }
      &-icon:hover {
        color: rgba(249, 129, 55, 0.9);
      }
    }
  }
}

.vue-poll .ans-cnt .ans .bg{
  position: absolute;
  width: 0;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  background-color: #409eff;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.page-content {
  border: 1px solid #eee;
  padding: 10px;
  /deep/ .mc-img {
    max-width: 100%;
  }
  /deep/ a {
    text-decoration: none;
    color: #01396B;
  }
  /deep/ p {
    color: #000000;
  }
}

.page-content-text {
  white-space: pre-wrap;
}

.mc-img {
  max-width: 100%;
}
/deep/.el-dialog {
  box-shadow: none;
  background: none;
}
/deep/.el-dialog__headerbtn {
  right: -20px;
  font-size: 20px;
}
.preview {
  width: 250px;
  height: 500px;
  overflow: hidden;
  .phoneBorder {
    width: 468px;
    height: 944px;
    background-image: url(../../../static/images/material/material_phone.png);
    background-repeat: no-repeat;
    background-size: 500px 944px;
    padding-top: 114px;
    padding-left: 30px;
    border-radius: 58px;
    overflow: hidden;
    transform: scale(0.5);
    transform-origin: 0 0;
    .page-content {
      width: 416px;
      height: 700px;
      overflow-y: scroll;
    }
  }
}
</style>
